export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/turnkey", label: "Turnkey" },
  { to: "/projects", label: "Projects" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

export const MARQUEE_ITEMS = [
  "Architecture",
  "Construction",
  "Interiors",
  "Electrical",
  "Plumbing",
  "Furniture",
  "Landscaping",
  "Handover",
];

export const STATS = [
  { value: "40+", label: "Clients & Partners" },
  { value: "06", label: "Landmark Bungalows" },
  { value: "11", label: "Turnkey Consultancies" },
  { value: "14", label: "Specialist Services" },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Safety Before Everything Else",
    image: "/images/values/safety.png",
    text: "Safety leads every decision — design, materials, construction methods and the environments we hand over. Spaces people can work and live in without a second thought.",
  },
  {
    num: "02",
    title: "Sustainable Design & Structure",
    image: "/images/values/sustainable.png",
    text: "Quality is expected at every level — from the people working on site to the architect shaping the concept — so every structure stands durable and sustainable.",
  },
  {
    num: "03",
    title: "Minimum Carbon Footprint",
    image: "/images/values/carbon.png",
    text: "We plan and build to keep the ecological footprint of every project as low as practical, aiming for greener outcomes that go beyond basic regulations.",
  },
];

export const PROJECTS = [
  {
    id: "shivshakti-house",
    title: "ShivShakti House",
    category: "Private Villa",
    location: "Pawana, Lonavala",
    duration: "2018 – 2023",
    cost: "₹1,800 Lakhs",
    architect: "The BNK Group",
    status: "Completed",
    plot_area: "",
    builtup_area: "",
    scope: "Turnkey Construction",
    image: "/images/projects/shivshakti-4.png",
    gallery: [
      "/images/projects/shivshakti-4.png",
      "/images/projects/shivshakti-1.png",
      "/images/projects/shivshakti-2.png",
      "/images/projects/shivshakti-3.png",
    ],
    tags: ["Turnkey Construction", "Landscape Lighting", "RCC Structure"],
    description: [
      "Set against the Pawana hills, ShivShakti House is a multi-level residence that comes alive after dusk — terraces, walkways and gardens choreographed with warm architectural lighting.",
      "Executed by Sai Leela Decor as turnkey contractor for The BNK Group, the build covered structure, waterproofing, finishes and landscape across a dramatic sloping site.",
    ],
  },
  {
    id: "maati-bani",
    title: "Maati Bani",
    category: "Farmhouse",
    location: "Khandala",
    duration: "2024 – 2026",
    cost: "₹220 Lakhs",
    architect: "Muse Labs",
    status: "Ongoing",
    plot_area: "",
    builtup_area: "",
    scope: "Turnkey Construction",
    image: "/images/projects/maati-1.png",
    gallery: ["/images/projects/maati-1.png"],
    tags: ["Turnkey Construction", "Arched Verandahs", "In Progress"],
    description: [
      "Currently rising in Khandala, Maati Bani pairs arched verandahs and terracotta roofs with contemporary planning — a farmhouse designed by Muse Labs and built by Sai Leela Decor.",
      "The 2024–2026 programme covers civil structure, plaster, waterproofing and interior work, delivered in close coordination with the architect's studio.",
    ],
  },
  {
    id: "oberoi-villa",
    title: "Oberoi Villa",
    category: "Private Villa",
    location: "Karjat",
    duration: "2023 – 2024",
    cost: "₹150 Lakhs",
    architect: "SNK Studio",
    status: "Completed",
    plot_area: "",
    builtup_area: "",
    scope: "Turnkey Construction",
    image: "/images/projects/oberoi-1.png",
    gallery: [
      "/images/projects/oberoi-1.png",
      "/images/projects/oberoi-2.png",
      "/images/projects/oberoi-3.png",
      "/images/projects/oberoi-4.png",
    ],
    tags: ["Turnkey Villa", "Finishing Works"],
    description: [
      "A crisp contemporary villa in Karjat with sculpted plaster massing and deep shaded openings, built turnkey in collaboration with SNK Studio.",
      "Sai Leela Decor delivered the structure and finishes through 2023–2024 — from slab work and plastering to the final coat of paint.",
    ],
  },
  {
    id: "iyer-farm-house",
    title: "Iyer Farm House",
    category: "Farmhouse",
    location: "Shahpur",
    duration: "2021 – 2023",
    cost: "₹250 Lakhs",
    architect: "Ar. Surendra Khandalgale",
    status: "Completed",
    plot_area: "",
    builtup_area: "",
    scope: "Turnkey Construction",
    image: "/images/projects/iyer-1.png",
    gallery: ["/images/projects/iyer-1.png"],
    tags: ["Arched Verandah", "Turnkey"],
    description: [
      "A farmhouse of brick arches and deep overhangs in Shahpur, designed by Ar. Surendra Khandalgale and executed by Sai Leela Decor between 2021 and 2023.",
      "Traditional proportions meet modern RCC construction — a ₹250 lakh build delivered from foundation to handover.",
    ],
  },
  {
    id: "adhal-farm-house",
    title: "Adhal Farm House",
    category: "Farmhouse",
    location: "Karjat",
    duration: "2022 – 2023",
    cost: "₹115 Lakhs",
    architect: "Ar. Surendra Khandalgale & Sharddha Gaikwad",
    status: "Completed",
    plot_area: "",
    builtup_area: "",
    scope: "Turnkey Construction",
    image: "/images/projects/adhal-1.png",
    gallery: ["/images/projects/adhal-1.png"],
    tags: ["Bungalow", "Turnkey"],
    description: [
      "A two-storey farmhouse in Karjat with ornamental railing panels, generous terraces and a stone-clad base, completed in 2023.",
      "Delivered at ₹115 lakhs with full civil, electrical, plumbing and finishing scope by Sai Leela Decor.",
    ],
  },
  {
    id: "jojo-farm-house",
    title: "JoJo Farm House",
    category: "Farmhouse",
    location: "Nasik",
    duration: "2022 – 2023",
    cost: "₹50 Lakhs",
    architect: "Muse Labs",
    status: "Completed",
    plot_area: "",
    builtup_area: "",
    scope: "Turnkey Construction",
    image: "/images/projects/jojo-1.png",
    gallery: [
      "/images/projects/jojo-1.png",
      "/images/projects/jojo-2.png",
      "/images/projects/jojo-3.png",
      "/images/projects/jojo-4.png",
      "/images/projects/jojo-5.png",
      "/images/projects/jojo-6.png",
    ],
    tags: ["Exposed Brick", "Steel Canopy"],
    description: [
      "JoJo Farm House in Nasik pairs honest exposed brickwork with a lean steel canopy — a modest, material-forward build designed by Muse Labs.",
      "Executed by Sai Leela Decor through 2022–2023 at ₹50 lakhs, including structure, joinery and site works.",
    ],
  },
];

export const SERVICES = [
  {
    num: "01",
    title: "Bungalow Construction",
    image: "/images/services/civil.png",
    desc: "Complete civil execution of your bungalow — from excavation and RCC structure to brickwork, slabs and plastering, delivered with systematic supervision.",
    tags: ["Site Analysis", "RCC Structure", "Slab Work", "Brickwork", "Plastering"],
  },
  {
    num: "02",
    title: "Architecture & Design",
    image: "/images/projects/iyer-1.png",
    desc: "Architectural planning, 2D drawings, 3D elevations and structural design — coordinated with approvals so the project starts on solid paper.",
    tags: ["2D Drawings", "3D Elevation", "Structural Design", "Approvals & Coordination"],
  },
  {
    num: "03",
    title: "Interior Design",
    image: "/images/services/pop.png",
    desc: "Premium interior execution — modular kitchens, wardrobes, false ceilings, furniture, lighting and finishes designed as one composition.",
    tags: ["Modular Kitchen", "Wardrobes", "False Ceiling", "Lighting"],
  },
  {
    num: "04",
    title: "Turnkey Projects",
    image: "/images/projects/shivshakti-4.png",
    desc: "One team, one responsibility — BOQ-based costing, dedicated project management and quality control from plot to possession.",
    tags: ["BOQ & Costing", "Project Management", "Quality Control", "Final Handover"],
  },
  {
    num: "05",
    title: "Renovation",
    image: "/images/services/renovation.png",
    desc: "Structural repairs, waterproofing, repainting and upgrades that extend the life and value of an existing home.",
    tags: ["Building Repair", "Waterproofing", "Repainting", "Retro Fitting"],
  },
  {
    num: "06",
    title: "Landscape & Outdoor",
    image: "/images/services/landscaping.png",
    desc: "Gardens, entrance gates, pathways and outdoor lighting that complete the bungalow beyond its walls.",
    tags: ["Gardens", "Entrance Gates", "Pathways", "Outdoor Lighting"],
  },
];

export const TEAM = [
  {
    id: "aarav-mehta",
    name: "Aarav Mehta",
    role: "Founder & Principal Designer",
    bio: "Placeholder bio — eighteen years shaping bespoke residences with sculptural purity and an obsession for raw material integrity.",
    tags: ["Spatial Strategy", "Material Authorship"],
  },
  {
    id: "elena-dsouza",
    name: "Elena D'Souza",
    role: "Director, Interior Architecture",
    bio: "Placeholder bio — specialises in lighting choreography, acoustic atmosphere and the quiet drama of threshold spaces.",
    tags: ["Lighting", "Acoustics"],
  },
  {
    id: "vikram-shah",
    name: "Vikram Shah",
    role: "Head of Atelier & Joinery",
    bio: "Placeholder bio — curates rare marble blocks and exotic timbers, leading the workshop where every bespoke piece is born.",
    tags: ["Joinery", "Metalwork"],
  },
  {
    id: "maya-krishnan",
    name: "Maya Krishnan",
    role: "Design Lead, Styling & Curation",
    bio: "Placeholder bio — composes the final layer of every project: art, objects and textiles that turn architecture into sanctuary.",
    tags: ["Art Curation", "Styling"],
  },
];

export const TESTIMONIALS = [];

export const CLIENTS = [
  "Crompton Greaves",
  "Adani India Pvt Ltd",
  "Asahi Glass Pvt Ltd",
  "Deepak Fertilizer India Ltd",
  "Mutual Engineering Pvt Ltd",
  "Excel Industries",
  "Haware Builders",
  "Progressive Constructions",
  "BARC Mumbai",
  "BARC Boisar",
  "Vijay System",
  "Waman Hari Pethe",
  "Reliance Electric Supply",
  "Dosti Realities Pvt Ltd",
  "Mumbai Port Trust",
  "Cabot Pvt Ltd",
  "ZP, Thane",
  "Sarrex Pvt Ltd, Boisar",
  "Water Resource Department, Kokan",
  "Navi Mumbai Mahanagar Palika",
  "Kalpataru India Ltd",
  "Raheja College Santacruz",
  "Poddar ICSE School, Worli",
  "Jindal House, Bombay",
  "69 Avenue, Fatima Nagar, Pune",
  "Siaram Garments, Bhiwandi",
];

export const RESIDENTIAL_CLIENTS = [
  "Vishnupriya CHS, Nerul",
  "Avinash CHS, Ghatkopar",
  "Gelda Sadan CHS, Ghatkopar",
  "Akshardham CHS, Ghatkopar",
  "Mermaid Belapur, Navi Mumbai",
  "Desi Tadka, Khanda Colony",
  "Vanket Hotel Kamothe",
  "Kalpataru Ltd. (AURA) Ghatkopar Site BOC, LBS Marg",
  "Kalpataru Azure Tree Townships Pvt. Ltd., Mira Road Site",
  "Kalpataru IT House Pvt. Ltd., Thane Site",
  "JMC Projects (India) Ltd, Jogeshwari Site",
  "EverSmile Properties Pvt. Ltd., Mira Road Site",
  "Adhiraj Garden Cypress Bldg, Sector 5, Kharghar",
  "Kalpataru Siddhanchal (Thane) Phase 4, Siddhanchal Complex",
  "Metro Mall, West Pinnacle, Residence Complex, Kalyan East",
];

export const SOCIALS = {
  instagram: "https://instagram.com/saileeladecor",
  pinterest: "https://pinterest.com/saileeladecor",
  linkedin: "https://linkedin.com/company/saileeladecor",
  whatsapp: "https://wa.me/919833621791",
};

export const CONSULTANTS = [
  "Muse Lab",
  "Vishant Chandra Art Studios",
  "Think BNK",
  "SNK",
  "Designo",
  "Phoenics",
  "Stensil",
  "DHIPL Projects",
  "Andrea Bell",
  "Enclouser",
  "Studio Archiculture",
];

export const PROCESS = [
  { num: "01", title: "Consultation", text: "We listen to your requirements, your family's needs and your vision for the bungalow." },
  { num: "02", title: "Site Visit", text: "Our team visits your plot to study dimensions, approach, soil and surroundings." },
  { num: "03", title: "Requirement & Budget", text: "We freeze the scope together and align it with a realistic budget." },
  { num: "04", title: "Concept & Planning", text: "Architectural concepts and space planning tailored to your plot." },
  { num: "05", title: "3D Design & Approvals", text: "3D elevations of your future home, plus coordination for required approvals." },
  { num: "06", title: "BOQ & Final Quotation", text: "Transparent, itemised costing before any work begins." },
  { num: "07", title: "Construction", text: "Civil execution with systematic supervision and quality checks at every stage." },
  { num: "08", title: "Interiors", text: "Kitchens, wardrobes, ceilings, lighting, furniture and finishes." },
  { num: "09", title: "Quality Inspection", text: "Snag checks across structure, services and finishes — nothing is overlooked." },
  { num: "10", title: "Handover", text: "One complete home, ready to move in." },
];

export const CONTACT = {
  phone: "+91 98336 21791",
  email: "admin@saileeladecor.com",
  email2: "",
  address: "703/15, Mohan Palms, Katrap, Shirgaon, Badlapur, Thane District – 421503",
  hours: "Mon – Sat · 10:00 – 19:00 · Site visits by appointment",
  cities: ["Badlapur", "Thane", "Mumbai"],
};

export const JOURNEY = {
  eyebrow: "The Complete Journey",
  title: "From Plot to Possession",
  message: "Give us your plot and requirements. We take care of the rest.",
  steps: ["Plot", "Design", "Construction", "Interiors", "Landscape", "Handover"],
};

export const WHY_US = [
  { num: "01", title: "One Company. One Responsibility.", text: "Architecture, construction and interiors managed under one roof." },
  { num: "02", title: "Turnkey Execution", text: "No need to coordinate with multiple contractors." },
  { num: "03", title: "Transparent Costing", text: "Detailed BOQ and project costing before execution." },
  { num: "04", title: "Dedicated Project Management", text: "One team responsible for planning, execution and quality." },
  { num: "05", title: "Premium Materials", text: "Approved materials and brands according to project specifications." },
  { num: "06", title: "Quality-Controlled Construction", text: "Systematic supervision throughout the project." },
  { num: "07", title: "Complete Interior Execution", text: "Kitchen, wardrobes, furniture, ceilings, lighting and finishes." },
  { num: "08", title: "Final Handover", text: "One complete home, ready to move in." },
];

export const TURNKEY_SERVICES = [
  "Site Analysis", "Architectural Planning", "2D Drawings", "3D Elevation",
  "Structural Design", "Approvals & Coordination", "Civil Construction", "Plumbing",
  "Electrical", "Flooring", "Doors & Windows", "Painting",
  "False Ceiling", "Modular Kitchen", "Wardrobes", "Furniture",
  "Lighting", "Bathrooms", "Landscaping", "Final Handover",
];

export const QUALITY_STAGES = [
  { title: "RCC Work", image: "/images/services/slab.png" },
  { title: "Steel Reinforcement", image: "/images/services/rcc.png" },
  { title: "Brickwork", image: "/images/projects/jojo-3.png" },
  { title: "Waterproofing", image: "/images/services/waterproofing.png" },
  { title: "Electrical Conduits", image: "/images/services/electrical.png" },
  { title: "Plumbing Lines", image: "/images/services/plumbing.png" },
  { title: "Plastering", image: "/images/services/repair.png" },
  { title: "Flooring", image: "/images/detail-marble.png" },
  { title: "False Ceiling", image: "/images/services/pop.png" },
  { title: "Carpentry", image: "/images/detail-joinery.png" },
  { title: "Painting", image: "/images/services/plastering.png" },
  { title: "Final Interior", image: "/images/hero.png" },
];

export const COST_SECTION = {
  eyebrow: "Project Costing",
  title: "How Much Does It Cost to Build a Bungalow?",
  intro: "Every bungalow is different. Your project cost depends on the factors below — we prepare a detailed, itemised estimate before any work begins.",
  sub: "Get your approximate project cost",
  cta: "Request Estimate",
  factors: ["Plot size", "Built-up area", "Number of floors", "Structural design", "Material specification", "Flooring", "Doors & windows", "Kitchen", "Bathrooms", "Furniture", "Automation", "Landscaping", "Interior specifications"],
};

export const VIDEO_SECTION = {
  eyebrow: "Brand Film",
  title: "Your plot. Your vision. Our responsibility.",
  note: "A 60-second Sai Leela Decor film is in production — Plot → Design → Construction → Interiors → Handover.",
  url: "",
};

export const DEFAULT_CONTENT = {
  hero: {
    eyebrow: "Turnkey Bungalow Construction & Interiors",
    line1: "Build your dream bungalow.",
    line2: "We handle",
    line3: "everything.",
    subtext:
      "Complete turnkey bungalow construction and interiors — from architectural planning and civil construction to premium interiors, landscaping and final handover, across Thane, Mumbai and Maharashtra.",
    image: "/images/projects/shivshakti-1.png",
    sideText: "From Plot to Possession — Sai Leela Decor",
    ctaPrimary: "Book a Free Consultation",
    ctaSecondary: "View Our Projects",
  },
  intro: {
    eyebrow: "The Company",
    tag: "( Who We Are )",
    statement:
      "We design, construct and deliver complete turnkey bungalows — from civil construction to interiors. Your dream home. One team. One responsibility.",
  },
  cta: {
    eyebrow: "Plots & Projects Across Maharashtra",
    titleA: "Start your",
    titleB: "bungalow project.",
    button: "Get a Free Consultation",
  },
  about: {
    storyLead:
      "Sai Leela Decor is a trusted construction and space-development company — from civil engineering and renovation to waterproofing, electrical, plumbing, slab work, building repairs, plastering, painting, POP and interiors.",
    storyBody:
      "Whether the requirement is a smaller renovation or a larger construction assignment, our approach centres on careful planning, detailed execution and professional coordination. We build strong working relationships with clients, architects, subcontractors and suppliers — completing projects on schedule, within the agreed budget, and to a high standard of quality.",
    quote:
      "\u201cArchitecture could be understood as the construction of realities — the construction of worlds.\u201d",
    storyImage: "/images/projects/shivshakti-2.png",
  },
  marqueeItems: MARQUEE_ITEMS,
  journey: JOURNEY,
  whyUs: WHY_US,
  turnkeyServices: TURNKEY_SERVICES,
  qualityStages: QUALITY_STAGES,
  costSection: COST_SECTION,
  videoSection: VIDEO_SECTION,
  stats: STATS,
  manifesto: MANIFESTO,
  projects: PROJECTS,
  services: SERVICES,
  team: TEAM,
  testimonials: TESTIMONIALS,
  clients: CLIENTS,
  residentialClients: RESIDENTIAL_CLIENTS,
  socials: SOCIALS,
  consultants: CONSULTANTS,
  process: PROCESS,
  contact: CONTACT,
};
